import React from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { useMutation } from '@apollo/client';
import { DELETE_BOOKING_BY_BOOKING_ID, DELETE_GROUP_BY_GROUP_ID } from 'graphql/service';
import colors from 'constants/colors';
import { Container } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';
import { message } from 'antd';

const ModalCancelConfirm  = ({
  isOpen,
  setIsOpen,
  cancelRoomParams,
  setCancelRoomParams,
  roomNumber,
  bookingId,
  groupId,
  fullName,
  setItems,
  setBookingDetailsData,
  refetch
}) => {

  const [deleteBookingByBookingId, { deleteBookingLoading }] = useMutation(
    DELETE_BOOKING_BY_BOOKING_ID,
    {
      onCompleted: (data) => {
        if(data.deleteBooking.status === 'CANCELLED') {
          message.success('Booking has been deleted')
          setCancelRoomParams({})
          setIsOpen(false)
          refetch && refetch()
          setItems && setItems((prevItems) => prevItems.filter(item => item.id.split('/')[0] !== bookingId))
          setBookingDetailsData && setBookingDetailsData((prevData) => {
            if(prevData?.bookingByID?.bookingId === bookingId) {
              return { ...prevData, bookingByID: { ...prevData.bookingByID, status: 'CANCELLED' } };
            }
            return prevData;
          })
        } else {
          const content = 'Delete booking failed'
          debouncedErrorMessage(content);
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )

  const [deleteGroupByGroupId, { deleteGroupLoading}] = useMutation(
    DELETE_GROUP_BY_GROUP_ID,
    {
      onCompleted: (data) => {
        if(data.deleteGroup.isDeleted === true) {
          message.success('Group has been deleted')
          setCancelRoomParams({})
          setIsOpen(false)
          refetch && refetch()
          setItems && setItems((prevItems) => prevItems.filter(item => item.id.split('/')[1] !== groupId))
          setBookingDetailsData && setBookingDetailsData((prevData) => {
            if(prevData?.bookingByID?.group?.groupId === groupId) {
              return { ...prevData, bookingByID: { ...prevData.bookingByID, status: 'CANCELLED' } };
            }
            return prevData;
          })
        } else {
          const content = 'Delete group failed'
          debouncedErrorMessage(content);
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )

  const handleCancelRoom = () => {

    if(bookingId) {
      if (deleteBookingLoading) return
      deleteBookingByBookingId({
        variables: {
          bookingId: bookingId,
          input: cancelRoomParams
        },
      }) 
    } else if(groupId) {
      if (deleteGroupLoading) return
      deleteGroupByGroupId({
        variables: {
          groupId: groupId,
          input: cancelRoomParams
        }
      })
    } else {
      const content = 'No bookingId or groupId provided'
      debouncedErrorMessage(content);
    }
  }

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="modal-danger"
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            height: 100%;
          }
        }
        background: ${colors.black5};
        top: 179px;
      `}
    >
      <Container>
        <div className='text'>Are you sure you want to cancel{bookingId?' room ' + roomNumber: ' the entire booking for ' + fullName}?</div>
        <Button
          danger
          onClick={handleCancelRoom}
          data-loading={deleteBookingLoading || deleteGroupLoading}
          additionalstyle={`
            width: ${bookingId? '125px' : '191px'};
            margin-top: 24px;
          `} 
        >
          {(deleteBookingLoading || deleteGroupLoading)? null: bookingId? 'Cancel Room' : 'Cancel Entire Booking'}
        </Button>
      </Container>
    </MainModal>
  );
}

export default ModalCancelConfirm;
